/**
 * @generated SignedSource<<3899a22c5fb5f1d3128b839c67aa041b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RenameTomraRvmInput = {
  id: string;
  name?: string | null;
};
export type IntegrationTomraScreenSetNamesMutation$variables = {
  names: ReadonlyArray<RenameTomraRvmInput>;
};
export type IntegrationTomraScreenSetNamesMutation$data = {
  readonly store: {
    readonly setTomraRvmNames: ReadonlyArray<{
      readonly id: string | null;
      readonly name: string | null;
    } | null> | null;
  };
};
export type IntegrationTomraScreenSetNamesMutation = {
  response: IntegrationTomraScreenSetNamesMutation$data;
  variables: IntegrationTomraScreenSetNamesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "names"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "names",
            "variableName": "names"
          }
        ],
        "concreteType": "IntegrationTomraRVM",
        "kind": "LinkedField",
        "name": "setTomraRvmNames",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationTomraScreenSetNamesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationTomraScreenSetNamesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7bc4273b3d8b53b4241e8cd540a84a29",
    "id": null,
    "metadata": {},
    "name": "IntegrationTomraScreenSetNamesMutation",
    "operationKind": "mutation",
    "text": "mutation IntegrationTomraScreenSetNamesMutation(\n  $names: [RenameTomraRvmInput!]!\n) {\n  store {\n    setTomraRvmNames(names: $names) {\n      id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "db0e53f212d2287bee80cf782208a90a";

export default node;
